import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { combineClassNames } from '../../../../app/functions';
import * as Routes from '../../../../constants/routes';
import Circle from './circle';
import desktopBackground from '../../../../assets/images/club-strip-bg-desktop.svg';
import mobileBackground from '../../../../assets/images/club-strip-bg-mobile.svg';
import './index.scss';

const ClubStrip = () => {
    const userData = useSelector((store) => store.config.UserData);
    const translations = useSelector((store) => store.config.Translations);
    const data = useSelector((store) => store.data.HomepageData?.club_banner);
    const deviceState = useSelector((store) => store.state.deviceState);

    if (!data?.circles) {
        return null;
    }

    const { circles } = data;

    const isActive = (Number(data.active) === 1);
    const isMobile = (deviceState === 'mobile');

    return isActive && (
        <div
            id={translations['web_logo_alt'].replace(' ', '_')}
            className={combineClassNames(
                'club-strip-wrapper',
                userData && 'compact-wrapper',
            )}
        >
            <img 
                src={isMobile ? mobileBackground : desktopBackground} 
                alt="Club Strip Background" 
                className="background" 
            />
            
            <div
                className={combineClassNames(
                    'overlay',
                    userData && 'overlay-centered',
                )}
            >
                <div className="header-text">
                    <span className="bold">
                        {data.header_title}
                    </span>
                    {' '}
                    <span>
                        {data.header_subtitle}
                    </span>
                </div>

                <div className="circles">
                    {circles.map((cr, idx) =>
                        <Circle
                            key={`club-banner-circle-${cr.main_text}-${cr.order_num}-${idx}`}
                            icon={cr.media_id}
                            title={cr.main_text}
                            subtitle={cr.sub_text}
                        />
                    )}
                </div>
                
                {!userData && (
                    <div className="call-for-action">
                        <NavLink 
                            to={Routes.membership_check} 
                            className="button"
                        >
                            {data.join_in_btn_text}
                        </NavLink>
                        
                        <span className="message">
                            {data.join_in_text}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ClubStrip;